var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGileadLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 28,
    viewBox: "0 0 102 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 28,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_636_2391)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 978,
    transform: "translate(-659 -924)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-658.5 -16C-658.5 -21.2467 -654.247 -25.5 -649 -25.5H771C776.247 -25.5 780.5 -21.2467 780.5 -16V53.5H-658.5V-16Z",
    fill: "white",
    stroke: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2247 12.7907V17.4806C37.4516 17.7364 36.6786 17.8217 35.9055 17.8217C32.7272 17.8217 30.7516 16.031 30.7516 13.1318C30.7516 10.2325 32.7272 8.44183 35.9914 8.44183C37.0221 8.44183 38.1388 8.5271 39.0837 8.95346L39.4273 9.124L40.1145 7.3333L39.7709 7.16276C38.6542 6.7364 37.3657 6.48059 36.1632 6.48059C30.7516 6.48059 28.2605 9.89144 28.2605 13.1318C28.1746 14.9225 28.9477 16.6279 30.2362 17.8217C31.5247 19.1007 33.3285 19.7829 35.6478 19.7829C37.1939 19.7829 38.826 19.5271 40.2863 18.9302H40.4581V12.7907H38.2247Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9006 6.73645H44.5813V19.6977H46.9006V6.73645Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6006 17.6512V6.73645H51.2814V19.6977H59.6135V17.6512H53.6006Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7674 17.6512V13.7287H70.5226V11.8527H64.7674V8.61242H70.9521V6.73645H62.5341V19.6977H71.2098V17.6512H64.7674Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7996 9.29459C79.9714 9.63567 81.0881 12.876 81.4317 13.814H77.9098C77.9098 13.814 79.6278 9.63567 79.7996 9.29459ZM81.0022 6.73645H78.6829L73.7008 19.6977H76.0201L77.4803 15.8605H82.1188L83.5791 19.6977H86.0702L81.0022 6.73645Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.2984 8.27129C97.9241 7.16276 95.7766 6.48059 93.1138 6.48059H88.8188V8.44183H93.1138C95.0894 8.44183 96.6356 8.95346 97.5805 9.7209C98.3536 10.5736 98.7831 11.6821 98.7831 12.7907C98.869 14.0697 98.3536 15.4341 97.4087 16.3721C96.3779 17.31 94.7458 17.8217 92.7702 17.8217H91.1381V11.8527H88.8188V19.6124H88.9906C90.1932 19.7829 91.3099 19.7829 92.5125 19.7829C95.3471 19.7829 97.6664 18.9302 99.2125 17.6511C100.587 16.3721 101.274 14.5814 101.188 12.7907C101.188 11.0852 100.501 9.46509 99.2984 8.27129Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8733 0H20.7015C3.35006 1.62015 1.2026 13.0465 6.87189 16.7985C5.84111 20.9767 6.87189 20.9767 6.87189 20.9767C6.95779 19.6977 7.21548 18.5039 7.55907 17.2248C9.70653 8.95349 15.204 1.87597 20.7015 0.0852713C20.8733 0.170543 20.8733 0.170543 20.8733 0Z",
    fill: "#C51F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7566 2.89924V2.7287L19.5848 2.89924C18.2964 5.62792 17.6951 9.55041 16.7502 12.4496C15.4617 15.8605 13.2283 18.2481 9.79241 17.907V26.2636C9.79241 26.2636 0.601288 22.2558 0.601288 15.7752V3.66668L8.07445 2.98451C8.24624 2.98451 8.24624 2.98451 8.24624 2.81397H0V15.6899C0 23.0233 9.79241 27.031 9.79241 27.031C9.79241 27.031 19.7566 22.8527 19.7566 15.7752V2.89924Z",
    fill: "#C51F3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_636_2391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 978,
    fill: "white",
    transform: "translate(-659 -924)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGileadLogo);
export default __webpack_public_path__ + "static/media/gileadLogo.18d89962d3041186ffdd0255e4990da6.svg";
export { ForwardRef as ReactComponent };